var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUseHeart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#EEF0FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 21.5717L20 28.9997M20 28.9997L12.5 21.5717C12.0053 21.0903 11.6156 20.5117 11.3555 19.8723C11.0954 19.2329 10.9706 18.5466 10.9887 17.8566C11.0069 17.1666 11.1678 16.4878 11.4612 15.863C11.7545 15.2382 12.1741 14.6809 12.6935 14.2263C13.2128 13.7716 13.8207 13.4294 14.4788 13.2212C15.1369 13.013 15.831 12.9433 16.5174 13.0165C17.2037 13.0897 17.8675 13.3042 18.4669 13.6466C19.0662 13.9889 19.5882 14.4517 20 15.0057C20.4135 14.4557 20.9361 13.997 21.5351 13.6583C22.1341 13.3196 22.7965 13.1081 23.4809 13.0372C24.1654 12.9663 24.8571 13.0374 25.5128 13.2461C26.1685 13.4548 26.774 13.7966 27.2915 14.2501C27.8091 14.7035 28.2274 15.259 28.5204 15.8816C28.8134 16.5042 28.9747 17.1806 28.9943 17.8684C29.0139 18.5562 28.8913 19.2407 28.6341 19.8789C28.377 20.5172 27.9909 21.0955 27.5 21.5777L20 28.9997Z",
    stroke: "#2F49D1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUseHeart);
export default __webpack_public_path__ + "static/media/useHeart.8c949dfbeb630275c1f6706f3285a2a7.svg";
export { ForwardRef as ReactComponent };